import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import SaveIcon from '@material-ui/icons/GetApp';
import classNames from 'classnames';
import Loader from '../loader';
import Alert from '../alert';
import ResultTable from '../resultTable';
import {config,settings} from '../../config/config';
import axios from 'axios';

const styles = theme => ({
  icon: {
    marginRight: theme.spacing.unit * 2
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
      width: 1100,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  root: {
    flexGrow: 1
  },
  typography: {
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    backgroundColor: theme.palette.background.paper
  },
  paper: {
    padding: theme.spacing.unit * 2,
    color: theme.palette.text.secondary,
    boxShadow: "0px 0px 0px ",
    border: "1px solid #dedede"
  },
  paperDescription: {
    margin: "10px",
    padding: theme.spacing.unit * 2,
    color: theme.palette.text.secondary,
    boxShadow: "0px 0px 0px "
  }
});

class Index extends Component {

  constructor() {
    super();
    this.execDownload = this.execDownload.bind(this);
    this.alertHandleClose = this.alertHandleClose.bind(this);
  }

  state = {
    screenName: "",
    cursor: "-1",
    isLast: false,
    allDownload: false,
    isDownloading: false,
    isAlertOpen: false,
    alertErrorMessage: "",
    results:{
      data:[]
    }
  };

  async execDownload() {
    if (this.state.isDownloading) {
      return;
    }
    try {
      this.setState({isDownloading: true,isLast: false});
      let parameter = new URLSearchParams();
      parameter.append("type", "follower");
      parameter.append("keyword", this.state.screenName);
      parameter.append("cursor", this.state.cursor);
      parameter.append("allDownload", this.state.allDownload);
      const response = await axios.post(settings.url + "/get", parameter, config);
      if (response) {
        if(response.data.mes !== "ok"){
          throw response.data.reason;
        }else{
          const isLast = response.data.result.nextCursor === "-1" ? true : false;
          this.setState({isDownloading: false,results:{data:response.data.result.data}, cursor:response.data.result.nextCursor, isLast: isLast});
          this.props.updateApiLimits(response.data.result.apiLimits);
          if(localStorage.getItem("auto") === "true"){
            for (let i = 0; i < response.data.result.data.length; i++){
              const data = response.data.result.data;
              let link = document.createElement('a');
              link.download = settings.download + data[i]["fileName"];
              link.href = settings.download + data[i]["fileName"];
              link.click();
            }
          }
        }
      }
    } catch(e) {
      this.setState({isDownloading: false,isAlertOpen: true,alertErrorMessage: e});
    }
  }

  handleChangeText = name => event => {
    this.setState({[name]: event.target.value});
  };

  handleChangeChkbox = name => event => {
    this.setState({[name]: event.target.checked});
  };

  alertHandleClose(){
    this.setState({isAlertOpen:false});
  }

  render() {
    const {classes} = this.props;
    return (<div>
      <Grid container={true}>
        <Grid item={true} xs={12}>
          <Paper className={classes.paper}>
            <Typography component="h5" variant="h5" className={classes.typography}>
              ユーザーのフォロワーから
            </Typography>
            <form className={classes.container} noValidate="noValidate" autoComplete="off">
              <TextField id="outlined-name" label="スクリーンネーム(例:sazae_f)" className={classes.textField} value={this.state.screenName} fullWidth={true} onChange={this.handleChangeText('screenName')} margin="normal" variant="outlined"/>
              <TextField id="outlined-name" label="カーソル" className={classes.textField} value={this.state.cursor} fullWidth={true} onChange={this.handleChangeText('cursor')} margin="normal" variant="outlined"/>
              <FormControlLabel style={{
                  userSelect: "none"
                }} control={<Switch
                checked = {
                  this.state.autoDownload
                }
                onChange = {
                  this.handleChangeChkbox('allDownload')
                }
                value = "allDownload"
                />} label="まとめてダウンロード"/>
            </form>
            <Grid container={true} style={{
                alignItems: "center"
              }}>
              <Grid item={true} style={{
                  height: "60px",
                  display: "flex",
                  alignItems: "center"
                }}>
                <Button variant="contained" size="large" color="primary" className={classes.button} onClick={this.execDownload} disabled={this.state.isDownloading}>
                  <SaveIcon className={classNames(classes.leftIcon, classes.iconSmall)} style={{
                      marginRight: "5px"
                    }}/>
                  ダウンロード
                </Button>
              </Grid>
              <Grid item={true}>
                <Loader isVisible={this.state.isDownloading}/>
              </Grid>
            </Grid>
            <Paper>
              {this.state.isLast && <p>次のカーソルがありません!(全部取得完了)</p>}
              <ResultTable results={this.state.results}/>
            </Paper>
            <Paper className={classes.paperDescription}>
              スクリーンネームを入力し、カーソルを入力します。<br/>
              カーソルは-1から始まります。フォロワーを取得する場合、一度に取得できる数が5000件に限られるので、5000以上のフォロワーが存在する場合は適宜カーソルを移動させてください。<br/>
              カーソルについて、取得完了した際にまだ次のカーソルが存在している場合は自動的にフォームに入力されますので、取得ボタンを押して続けてリストを取得することができます。<br/>
              一度に5000件以上取得する場合は「まとめてダウンロード」にチェックを入れてください。<br/>
              (followers/idsは15分ごとに15回までしかAPIを使用できないため、その制限を超えるリストは取得できません。)
            </Paper>
          </Paper>
        </Grid>
      </Grid>
      <Alert open={this.state.isAlertOpen} handleClose={this.alertHandleClose} errorMessage={this.state.alertErrorMessage}/>
    </div>)
  }
}

Index.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Index);
